module.exports = __webpack_public_path__ + "static/media/upload.e4837ff1.png";